import { render, staticRenderFns } from "./TabelaResultadosCategoria.vue?vue&type=template&id=3895c70f&scoped=true&"
import script from "./TabelaResultadosCategoria.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosCategoria.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosCategoria.vue?vue&type=style&index=0&id=3895c70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895c70f",
  null
  
)

export default component.exports